<template>
  <w-icon-wrapper
    icon-name='work-skill-icon'
    :height='24.073'
    :width='23.896'
    view-box='0 0 23.896 24.073'
  >
    <g
      id="_108_Skill_Icon"
      data-name="108_Skill_Icon"
      transform="translate(-1567.003 -2608.999)"
    >
      <path
        id="Pfad_40"
        data-name="Pfad 40"
        d="M40.811,14.692l-3.23-1.81a.138.138,0,0,0-.04.03l3.28,1.84Zm-9.09-5.12L28.7,7.882a.064.064,0,0,0,0,.06l3.05,1.71c-.01-.03-.02-.05-.03-.08m9.32,7.54-2.12-1.19.44,4.59-3.06-1.66-3.06,1.66.59-6.2a1.1,1.1,0,0,1,.31.22,3.234,3.234,0,0,0,2.29.95,3.06,3.06,0,0,0,1.26-.26l-7.68-4.31v.01a3.255,3.255,0,0,0,1.86,2.93l-.97,10.22,5.4-2.95,5.41,2.95Z"
        transform="translate(1543 2609)"
        fill="currentColor"
      />
      <path
        id="Pfad_41"
        data-name="Pfad 41"
        d="M47.391,16.162l-5.4-3.04a3.214,3.214,0,0,0,.87-2.2,1.24,1.24,0,0,1,.37-.89,3.247,3.247,0,0,0,0-4.59,1.217,1.217,0,0,1-.37-.88,3.241,3.241,0,0,0-3.25-3.24,1.217,1.217,0,0,1-.88-.37,3.241,3.241,0,0,0-4.59,0,1.3,1.3,0,0,1-.88.37,3.248,3.248,0,0,0-3.25,3.24,1.217,1.217,0,0,1-.37.88,3.891,3.891,0,0,0-.41.5l-3.74-2.1A1,1,0,0,0,24.4,5.5h.01a1.223,1.223,0,0,1,.24.1l4.05,2.28,3.02,1.69,5.86,3.31,3.23,1.81,5.74,3.23a.254.254,0,0,1,.1.08h.01a.993.993,0,0,0,1.11-.48,1,1,0,0,0-.38-1.36m-9.76-5.49a5.218,5.218,0,0,0,1.69-.68c.17-.12.35-.23.51-.36a2.576,2.576,0,0,0-.21-.57,3.417,3.417,0,0,0-2.03-1.76,1.818,1.818,0,0,0,.73-1.45,1.89,1.89,0,0,0-3.78,0,1.8,1.8,0,0,0,.74,1.45,3.472,3.472,0,0,0-1.64,1.13L31,6.942a.21.21,0,0,1,.06-.08,3.255,3.255,0,0,0,.95-2.3,1.242,1.242,0,0,1,1.25-1.24,3.2,3.2,0,0,0,2.29-.96,1.258,1.258,0,0,1,.88-.36,1.241,1.241,0,0,1,.88.36,3.288,3.288,0,0,0,2.31.96,1.24,1.24,0,0,1,1.24,1.24,3.223,3.223,0,0,0,.96,2.3,1.243,1.243,0,0,1-.01,1.76,3.237,3.237,0,0,0-.95,2.3,1.189,1.189,0,0,1-.33.83,1.217,1.217,0,0,1-.43.31Z"
        transform="translate(1543 2609)"
        fill="currentColor"
      />
      <path
        id="Pfad_42"
        data-name="Pfad 42"
        d="M46.651,18a1.223,1.223,0,0,1-.24-.1l-5.59-3.15-3.28-1.84-5.79-3.26L28.7,7.943l-4.19-2.36a.254.254,0,0,1-.1-.08,1.223,1.223,0,0,1,.24.1l4.05,2.28,3.02,1.69,5.86,3.31,3.23,1.81,5.74,3.23a.254.254,0,0,1,.1.08"
        transform="translate(1543 2609)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconSkill' };
</script>
